import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';

export const INSURANCE_ENDORSEMENT_DELTA_SCHEMAS: Record<string, StructuredJsonFieldDef[]> = {
  ChangeCoverage: [
    {
      key: 'coverageCode',
      type: 'select',
      labelKey: 'insurance.policyDetail.endorsement.delta.coverageCode',
      required: true
    },
    {
      key: 'sumInsuredDelta',
      type: 'number',
      labelKey: 'insurance.policyDetail.endorsement.delta.sumInsuredDelta'
    }
  ],
  ChangeRisk: [
    {
      key: 'risk',
      type: 'textarea',
      labelKey: 'insurance.policyDetail.endorsement.delta.risk',
      required: true
    }
  ],
  ChangeParty: [
    {
      key: 'partyId',
      type: 'party',
      labelKey: 'insurance.policyDetail.endorsement.delta.partyId',
      required: true
    },
    {
      key: 'role',
      type: 'select',
      labelKey: 'insurance.policyDetail.endorsement.delta.role',
      required: true,
      options: [
        { value: 'Policyholder', labelKey: 'insurance.policyDetail.parties.roles.policyholder' },
        { value: 'Insured', labelKey: 'insurance.policyDetail.parties.roles.insured' },
        { value: 'Beneficiary', labelKey: 'insurance.policyDetail.parties.roles.beneficiary' },
        { value: 'Payer', labelKey: 'insurance.policyDetail.parties.roles.payer' },
        { value: 'LossPayee', labelKey: 'insurance.policyDetail.parties.roles.lossPayee' }
      ]
    },
    {
      key: 'action',
      type: 'select',
      labelKey: 'insurance.policyDetail.endorsement.delta.action',
      required: true,
      options: [
        { value: 'Add', labelKey: 'insurance.policyDetail.endorsement.delta.actions.add' },
        { value: 'Remove', labelKey: 'insurance.policyDetail.endorsement.delta.actions.remove' },
        { value: 'Replace', labelKey: 'insurance.policyDetail.endorsement.delta.actions.replace' }
      ]
    }
  ],
  Cancellation: [
    {
      key: 'reason',
      type: 'textarea',
      labelKey: 'insurance.policyDetail.endorsement.delta.reason',
      required: true
    }
  ],
  Other: [
    {
      key: 'description',
      type: 'textarea',
      labelKey: 'insurance.policyDetail.endorsement.delta.description',
      required: true
    },
    {
      key: 'reference',
      type: 'string',
      labelKey: 'insurance.policyDetail.endorsement.delta.reference'
    }
  ]
};

export function getEndorsementDeltaFields(type: string): StructuredJsonFieldDef[] {
  return INSURANCE_ENDORSEMENT_DELTA_SCHEMAS[type] ?? INSURANCE_ENDORSEMENT_DELTA_SCHEMAS['Other'];
}
